export function closeApp() {
  window.close();
}
